<template>
  <UpperHeader :headers="headerStore.headers.upper" v-if="$deviceStore.deviceType == 'desktop'" :userMenu="headerStore.headers.userMenu" />
  <LowerHeader :headers="headerStore.headers.lower" v-if="$deviceStore.deviceType == 'desktop'" />
  <MHeader :headers="headerStore.headers" v-if="$deviceStore.deviceType != 'desktop'" />
</template>

<script>
import UpperHeader from '@/Header/Desktop/UpperHeader.vue';
import LowerHeader from '@/Header/Desktop/LowerHeader.vue';

import MHeader from '@/Header/Mobile/MHeader.vue';

import { useHeaderStore } from '@/store/headerStore.js';

export default {
  name: 'HeaderComponent',
  components: {
    UpperHeader,
    LowerHeader,
    MHeader,
  },
  setup() {
    const headerStore = useHeaderStore();
    return { headerStore };
  },
};
</script>